import { useQuery } from '@tanstack/react-query';
import { TRADING_ELOQUENT as ELOQUENT } from 'config/constants';
import { queryClientKeys } from 'config/executors/apiInterceptor';

/**
 * Get products
 * @param {Object} data
 * @returns {Promise}
 */
export function getProducts(data) {
    return ELOQUENT.Products.index(data);
}

/**
 * Create product
 * @param {Object} data
 * @returns {Promise}
 */
export function createProduct(data, { token }) {
    return ELOQUENT.Products.create(data, token);
}

/**
 * update product
 * @param {Number} id
 * @param {Object} data
 * @returns {Promise}
 */
export function updateProduct(id, data, { token }) {
    return ELOQUENT.Products.update(id, data, token);
}

/**
 * update product status
 * @param {Number} id
 * @param {String} data
 * @returns {Promise}
 */
export function updateProductStatus(id, data, { token }) {
    return ELOQUENT.Products.updateStatus(id, data, token);
}

/**
 * Retrieve single product type record.
 * @param {Number} id
 * @returns {Promise}
 */
export function getProductType(id) {
    return ELOQUENT.ProductTypes.show(id);
}

export const useGetProductTypeApi = (apiCaller, id) => {
    const query = useQuery({
        queryKey: [queryClientKeys.useGetProductTypeApi, id],
        enabled: !!id,
        queryFn: async ee => {
            const id = ee.queryKey[1];

            return await apiCaller(getProductType, id);
        }
    });

    return { ...query, data: query.data?.data };
};

/**
 * Retrieve single product type record.
 * @returns {Promise}
 */
export function getProductEncoTerms() {
    return ELOQUENT.Incoterms.index();
}

export const useGetProductEncoTermsApi = (apiCaller) => {
    const query = useQuery({
        queryKey: [queryClientKeys.useGetProductEncoTermsApi],
        queryFn: async ee => {
            return await apiCaller(getProductEncoTerms);
        }
    });

    return { ...query, data: query.data?.data?.data };
};
